var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00607f",
    d: "M497 121H256.05c-8.284 0-15 6.716-15 15v240c0 8.284 6.716 15 15 15H497c8.284 0 15-6.716 15-15V136c0-8.284-6.716-15-15-15z",
    opacity: 1,
    "data-original": "#00607f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00465f",
    d: "M512 256v120c0 8.28-6.72 15-15 15H256.05c-8.28 0-15-6.72-15-15V256z",
    opacity: 1,
    "data-original": "#00465f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e9f4ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.05 151h30v30h-30zM331.05 151h30v30h-30zM271.05 151h30v30h-30z",
    fill: "#e9f4ff",
    opacity: 1,
    "data-original": "#e9f4ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#cbe2ff",
    d: "M271.05 330.95h30V361h-30zM331.05 330.95h30V361h-30zM391.05 330.95h30V361h-30z",
    opacity: 1,
    "data-original": "#cbe2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6da6ff",
    d: "M271.05 211H482v89.95H271.05z",
    opacity: 1,
    "data-original": "#6da6ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d7ff5",
    d: "M271.05 256H482v44.95H271.05z",
    opacity: 1,
    "data-original": "#4d7ff5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9f4ff",
    d: "M451.05 151H482v30h-30.95z",
    opacity: 1,
    "data-original": "#e9f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cbe2ff",
    d: "M451.05 330.95H482V361h-30.95z",
    opacity: 1,
    "data-original": "#cbe2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00607f",
    d: "M136.05 121H15c-8.284 0-15 6.716-15 15v240c0 8.284 6.716 15 15 15h121.05c8.284 0 15-6.716 15-15V136c0-8.284-6.716-15-15-15z",
    opacity: 1,
    "data-original": "#00607f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00465f",
    d: "M151.05 256v120c0 8.28-6.72 15-15 15H15c-8.28 0-15-6.72-15-15V256z",
    opacity: 1,
    "data-original": "#00465f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6da6ff",
    d: "M30 211h91.05v89.95H30z",
    opacity: 1,
    "data-original": "#6da6ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d7ff5",
    d: "M30 256h91.05v44.95H30z",
    opacity: 1,
    "data-original": "#4d7ff5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9f4ff",
    d: "M91.05 151h30v30h-30z",
    opacity: 1,
    "data-original": "#e9f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cbe2ff",
    d: "M91.05 330.95h30V361h-30z",
    opacity: 1,
    "data-original": "#cbe2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9f4ff",
    d: "M30 151h31.05v30H30z",
    opacity: 1,
    "data-original": "#e9f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cbe2ff",
    d: "M30 330.95h31.05V361H30z",
    opacity: 1,
    "data-original": "#cbe2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b28",
    d: "m181.05 400.239-41.193 45.72A15.001 15.001 0 0 0 136 456v41c0 8.284 6.716 15 15 15h90c8.284 0 15-6.716 15-15v-41c0-3.703-1.369-7.274-3.845-10.028l-41.105-45.723V256L197 246l-15.95 10z",
    opacity: 1,
    "data-original": "#ff4b28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7829",
    d: "M252.144 66.041A15.005 15.005 0 0 0 256 56V15c0-8.284-6.716-15-15-15h-90c-8.284 0-15 6.716-15 15v41c0 3.703 1.369 7.274 3.845 10.028l41.205 45.728V256h30V111.756z",
    opacity: 1,
    "data-original": "#ff7829",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a0c6ec8ee2358c16672cee093aebd1e4.svg";
export { ForwardRef as ReactComponent };